import { graphql, Link, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React, {useContext} from "react"
import {Button, Col, Container, Image, Nav, Row} from "react-bootstrap"
import Logo from "../../../static/images/logo.inline.svg"
import LogoWhite from "../../images/logo-inline-white.svg"
import { Email, LinkedIn, Twitter } from "../Icons"
import { StyledLink } from "../StyledLink"
import "./styles.scss"
import CookieConsent, {Cookies, getCookieConsentValue} from "react-cookie-consent";
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'
import {ModalContext} from "../layout";
import {useLocation} from "@reach/router";

const Footer = ({ siteTitle, newFooter, customButton = null, sideText }) => {
  const location = useLocation();
  const path = location.pathname ? location.pathname : ""
  const [, setShowModal] = useContext(ModalContext)
  const openModal = () => setShowModal(true)
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            blog
            socialLinks {
              twitter
              linkedin
            }
          }
        }
      }
    `
  )

  const CustomCookieConsent = () => {
    return  <Row>
      <Col>
        <CookieConsent
            location="bottom"
            buttonText="Accept"
            cookieName="team-coaches-google-analytics"
            style={{
              background: "rgb(52, 58, 64)",
              color: 'white',
              fontSize: '1.2em',
              paddingLeft: '5em',
              fontFamily: 'Nunito'
            }}
            buttonStyle={{
              color: "black",
              borderRadius: '5em',
              fontSize: '.9em',
              textTransform: 'capitalize',
              padding: '.5em 2em',
              marginRight: '10em'
            }}
            onAccept={() => {
              initializeAndTrack(window.location)
            }}
        >
          Team Coaches uses cookies to enhance your user experience. &nbsp;&nbsp;&nbsp;
          <a
              href="https://teamcoach.es/cookies-policy/"
              className="text-light text-underline"
              target="_blank"
              rel="noopener noreferrer"
          >
            Read Cookie Policy
          </a>
        </CookieConsent>
      </Col>
    </Row>
  }
  if(newFooter) {
    return <Container
        className="font-centered-14 px-4"
        fluid
        style={{
          backgroundColor: "#0F3857",
          color: 'white',
          backgroundSize: "cover",
        }}
    >
      <Row className="d-flex flex-row align-items-center justify-content-center mt" style={{ marginTop: '-12em'}}>
        <Col
            xs={11}
            lg={9}
            style={{ backgroundColor: '#1F7ABF', height: '18em',  borderRadius: '.5em', marginTop: '-9em' }}
            className="d-flex flex-row align-items-center justify-content-center"
        >
          <Row>
            <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }} className="d-flex align-items-center justify-content-center">
              {customButton ? customButton() : (
                  <Button
                      onClick={openModal}
                      className="mt-4 mt-md-0 py-2 bg-white fw-bold"
                      style={{
                        width: '15em',
                        borderRadius: '.5em',
                        color: '#1F7ABF',
                      }}
                  >
                    Let's Talk
                  </Button>
              )}
            </Col>
            <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 2 }} className="text-center px-0">
              <h2 className="px-1" style={{ lineHeight: '1.8em' }}>
                { sideText || "“The best platform for teams innovating the world.”" }
              </h2>
            </Col>
          </Row>
        </Col>
      </Row>
      <Container className="mt-5" style={{ borderTop: '.1em solid white'}}>
        <Row className="pt-4">
          <Col xs={12} className="d-flex flex-row justify-content-center justify-content-md-start">
            <Image src={LogoWhite} style={{ width: '15em'}} />
          </Col>
          <Col xs={12}>
            <Row className="text-center text-md-start">
              <Col xs={3}></Col>
              <Col>
                <span className="h4 text-white">Quick Links</span>
                <Nav className="d-md-flex flex-column">
                  <Nav.Item>
                    <Nav.Link as={Link} to="/product" style={{color: 'white'}}>
                      Product
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={Link} to="/public-portfolios" style={{color: 'white'}}>
                      Public Portfolios
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={Link} to="/support" style={{color: 'white'}}>
                      Support
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={Link} to="/faqs" style={{color: 'white'}}>
                      FAQs
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={Link} href="https://blog.teamcoach.es/" style={{color: 'white'}}>
                      Blog
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col>
                <span className="h4 text-white">Follow Us</span>
                <Nav className="d-md-flex flex-column">
                  <Nav.Item>
                    <Nav.Link
                        href={site.siteMetadata.socialLinks.twitter}
                        target="_blank"
                        rel="noopener"
                        style={{color: 'white'}}
                    >
                      <Twitter width="24" height="24" />&nbsp; Twitter
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                        href={site.siteMetadata.socialLinks.linkedin}
                        target="_blank"
                        rel="noopener"
                        style={{color: 'white'}}
                    >
                      <LinkedIn width="24" height="24" />&nbsp; LinkedIn
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col>
                <span className="h4 text-white">Reach Us</span>
                <Nav className="d-md-flex flex-column">
                  <Nav.Item className="d-md-flex align-items-center">
                    <Nav.Link rel="noopener" href="mailto:info@teamcoach.es" style={{color: 'white'}}>
                      <span>
                        <span style={{ marginRight: "5px" }}>
                          <Email width="24" height="24" />
                        </span>{" "}
                        <span className="text-white">info@teamcoach.es</span>
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="footer-end-row px-4 mt-4" style={{ borderTop: '.01em solid white' }}>
          <Col md={5} className="align-self-center text-white p-4">
            <span style={{color: 'white'}}>©2020 - {new Date().getFullYear()} Team Coaches Inc. All rights reserved.</span>
          </Col>
          <Col sm md={7}>
            <Nav className="text-white d-flex justify-content-center justify-content-md-end align-items-center">
              <Nav.Item>
                <StyledLink to="/terms-of-use"  style={{color: 'white'}}>Terms &amp; Conditions</StyledLink>
              </Nav.Item>
              <span className={"vline-light-gray"}>|</span>
              <Nav.Item>
                <StyledLink to="/privacy-policy" style={{color: 'white'}}>Privacy Policy</StyledLink>
              </Nav.Item>
              <span className="vline-light-gray">|</span>
              <Nav.Item>
                <StyledLink to="/cookies-policy" style={{color: 'white'}}>Disclaimer</StyledLink>
              </Nav.Item>
              <span className="vline-light-gray">|</span>
              <Nav.Item>
                <StyledLink to="/gdpr" style={{color: 'white'}}>GDPR</StyledLink>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>
        <CustomCookieConsent />
      </Container>
    </Container>
  }
  return (
    <Container
      className="  p-4"
      fluid
      style={{
        backgroundColor: "#F2F7FF",
        backgroundSize: "cover",
      }}
    >
      <Row className="px-4 text-center text-md-start">
        <Col xs={12} md={3} className="col-logo">
          <Logo
            className="nav-logo mb-3"
            style={{
              maxWidth: "10.938em",
              maxHeight: "1.875em",
            }}
          />
          <small className="d-block">
            Team Coaches is the world&apos;s most advanced innovation
            relationship management platform, which offers the tools necessary
            for scaling modern accelerator, incubator and venture capital
            communities.
          </small>
        </Col>
        <Col xs={6} md={3} className="col-quicklinks">
          <span className="h4">Quick Links</span>
          <Nav className="d-md-flex flex-column">
            <Nav.Item>
              <Nav.Link as={Link} to="/product">
                Product
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/public-portfolios">
                Public Portfolios
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/support">
                Support
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/faqs">
                FAQs
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} href="https://blog.teamcoach.es/">
                Blog
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col xs={6} md={2} className="col-quicklinks">
          <span className="h4">Follow Us</span>
          <Nav className="d-md-flex flex-column">
            <Nav.Item>
              <Nav.Link
                href={site.siteMetadata.socialLinks.twitter}
                target="_blank"
                rel="noopener"
              >
                <Twitter width="12.8" height="12.8" /> Twitter
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                href={site.siteMetadata.socialLinks.linkedin}
                target="_blank"
                rel="noopener"
              >
                <LinkedIn width="12.8" height="12.8" /> LinkedIn
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col xs={12} md={4} className="col-quicklinks">
          <span className="h4">Reach Us</span>
          <Nav className="d-md-flex flex-column">
            <Nav.Item className="d-md-flex align-items-center">
              <Nav.Link rel="noopener" href="mailto:info@teamcoach.es">
                <span>
                  <span style={{ marginRight: "5px" }}>
                    <Email width="24" height="24" />
                  </span>{" "}
                  <span>info@teamcoach.es</span>
                </span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
      </Row>
      <Row className="footer-end-row px-4">
        <Col md={5} className="align-self-center p-4">
          <span>© 2020 - 2023 Team Coaches Inc. All rights reserved.</span>
        </Col>
        <Col sm md={7}>
          <Nav className="d-flex justify-content-center justify-content-md-end align-items-center">
            <Nav.Item>
              <StyledLink to="/terms-of-use">Terms &amp; Conditions</StyledLink>
            </Nav.Item>
            <span className={"vline-light-gray"}>|</span>
            <Nav.Item>
              <StyledLink to="/privacy-policy">Privacy Policy</StyledLink>
            </Nav.Item>
            <span className="vline-light-gray">|</span>
            <Nav.Item>
              <StyledLink to="/cookies-policy">Disclaimer</StyledLink>
            </Nav.Item>
            <span className="vline-light-gray">|</span>
            <Nav.Item>
              <StyledLink to="/gdpr">GDPR</StyledLink>
            </Nav.Item>
          </Nav>
        </Col>
      </Row>
     <CustomCookieConsent />
    </Container>
  )
}

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
